import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/home/hermane/Dev/node/open-source/SmartCal/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "api/Compile.d.ts",
    "revision": "549a1cd629e5bbebd278d24fdcfa873a"
  },
  {
    "url": "api/SmartCal.d.ts",
    "revision": "b385f7472b1ca58f86156384b538c9b1"
  },
  {
    "url": "api/index.d.ts",
    "revision": "e8dccd17c8489986a48600a7a32ec321"
  },
  {
    "url": "api/isValidExpression.d.ts",
    "revision": "9565d543de810fc78347cd2372e5675f"
  },
  {
    "url": "builder/ExpressionBuilder.d.ts",
    "revision": "e8f2e1e177b7cbf72586a5a819f909fb"
  },
  {
    "url": "constant.d.ts",
    "revision": "8f755f3e6f596fde8e4f488eeed71835"
  },
  {
    "url": "errors/FormulaInterpreterError.d.ts",
    "revision": "286402b81ccd7880b2f2f58bd7e85cc5"
  },
  {
    "url": "expression/BinaryOperation.d.ts",
    "revision": "fbf85a7493adf83eeb3ce05f13f97008"
  },
  {
    "url": "expression/CompiledExpression.d.ts",
    "revision": "96293310eb085c676b647becbb7ad562"
  },
  {
    "url": "expression/ConditionalExpression.d.ts",
    "revision": "ad2d11bf4a19340fbdbd7e882d0863ef"
  },
  {
    "url": "expression/Expression.d.ts",
    "revision": "6c13d20dd5bd40285e0f342d19b96e7f"
  },
  {
    "url": "expression/ExpressionConstructor.d.ts",
    "revision": "5db7e5ca751acda022c1b7ac1ae1d6ea"
  },
  {
    "url": "expression/FieldReference.d.ts",
    "revision": "4a2394727ce86098d4dcc7bf76021a25"
  },
  {
    "url": "expression/LiteralValue.d.ts",
    "revision": "9b0f1fe7d7a2d93bc595beb3894840e7"
  },
  {
    "url": "index.d.ts",
    "revision": "dc57ea2c3a268f19a68ec32dbd981044"
  },
  {
    "url": "index.js",
    "revision": "7d33ca8925064cde4369719ff94d99d0"
  },
  {
    "url": "interpreter/FormulaInterpreter.d.ts",
    "revision": "d622ef00e73850e354c8f17883f6b9be"
  },
  {
    "url": "parser/AstNode.d.ts",
    "revision": "6eb4dc322e030634c419b005db909212"
  },
  {
    "url": "parser/FormulaParser.d.ts",
    "revision": "7304c27252a76ba0f148f4b6dc82bf5b"
  },
  {
    "url": "test/tokenizer/FormulaTokenizer.test.d.ts",
    "revision": "e2ebd7ddedcadeeadbf819c35985c768"
  },
  {
    "url": "tokenizer/FormulaTokenizer.d.ts",
    "revision": "0efca045b5dcb420a0fa397c3b52ca3b"
  },
  {
    "url": "types/index.d.ts",
    "revision": "38f035611b8ffdcc2b98197cc23355d2"
  }
], {});








